
require('./bootstrap');
require('jquery-validation');
require('./password-generator');
require('./md5-generator')
const {md5Generator} = require("./md5-generator");
const {Base64EncoderDecoder} = require("./base64-encoder-decoder");

$(function() {

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('.csrf').val()
        }
    });

    //passwordGenerator.init();
    md5Generator.init();
    Base64EncoderDecoder.init();



    /**
     * Cookie
     */
    $('.cookies .close').on('click',function(){
        Cookies.set('cookie_accepted', '1', { expires: 7 });
        $('.cookies').slideUp(500);

        return false;
    });
});
